import React, { useState } from "react";
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import ProductDetailNow from "./ProductDetailNow";
import { useEffect } from "react";
import {
  getProductWithSingleOptionDefaults,
  getVariantQuantity,
  isVariantSelectionComplete,
} from "../../helpers/ProductOptionDefaults";
import { AddCommaNumber } from "../../helpers/Utils";
import { NotificationManager } from "../../components/common/react-notifications";
import PerfectScrollbar from "react-perfect-scrollbar";
import IntlMessages from "../../helpers/IntlMessages";

const ContentComponent = ({
  product,
  productDetail,
  setProductDetail,
  onToggleDetail,
  onClickImage,
}) => {
  // State để lưu trữ sản phẩm với các tùy chọn đã được chọn từ ProductDetailNow
  const [fullySelectedProduct, setFullySelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [showErrors, setShowErrors] = useState(false);

  useEffect(() => {
    // Khi modal mở, reset trạng thái
    if (product) {
      setFullySelectedProduct(getProductWithSingleOptionDefaults(product));
      setQuantity(1);
      setShowErrors(false);
    }
  }, [product?.id]);

  const targetProduct = fullySelectedProduct || product || {};
  const bt = String(targetProduct?.business_type || "")
    .toLowerCase()
    .trim();
  const isFnB = bt === "cafe" || bt === "restaurant";

  // Kiểm tra xem tất cả các thuộc tính bắt buộc đã được chọn chưa
  const variantSelectionComplete =
    isVariantSelectionComplete(fullySelectedProduct);
  const isFlavorSelectionComplete =
    !isFnB ||
    fullySelectedProduct?.variants?.length > 0 ||
    !Array.isArray(fullySelectedProduct?.flavor) ||
    !fullySelectedProduct?.flavor?.length ||
    fullySelectedProduct.flavorSelectedId?.length > 0;

  const isSizeSelectionComplete =
    !isFnB ||
    fullySelectedProduct?.variants?.length > 0 ||
    !Array.isArray(fullySelectedProduct?.size) ||
    !fullySelectedProduct?.size?.length ||
    fullySelectedProduct.sizeSelectedId?.length > 0;
  const selectedVariantQuantity =
    fullySelectedProduct?.selectedVariantQuantity !== undefined
      ? fullySelectedProduct.selectedVariantQuantity
      : getVariantQuantity(fullySelectedProduct?.selectedVariant);
  const hasSelectedVariantQuantity =
    selectedVariantQuantity !== null && selectedVariantQuantity !== undefined;
  const isSelectedVariantOutOfStock =
    hasSelectedVariantQuantity && selectedVariantQuantity <= 0;

  useEffect(() => {
    if (!hasSelectedVariantQuantity || selectedVariantQuantity <= 0) return;

    setQuantity((prevQuantity) =>
      prevQuantity > selectedVariantQuantity
        ? selectedVariantQuantity
        : prevQuantity,
    );
  }, [hasSelectedVariantQuantity, selectedVariantQuantity]);

  const handleQuantityChange = (e) => {
    const nextQuantity = parseInt(e.target.value, 10);
    if (Number.isNaN(nextQuantity)) {
      setQuantity(1);
      return;
    }

    const normalizedQuantity = nextQuantity < 1 ? 1 : nextQuantity;
    if (hasSelectedVariantQuantity && selectedVariantQuantity > 0) {
      setQuantity(
        normalizedQuantity > selectedVariantQuantity
          ? selectedVariantQuantity
          : normalizedQuantity,
      );
      return;
    }

    setQuantity(normalizedQuantity);
  };

  const handleAddToCart = async () => {
    let hasError = false;

    if (fullySelectedProduct?.variants?.length && !variantSelectionComplete) {
      NotificationManager.warning(
        "Vui lòng chọn đầy đủ thuộc tính biến thể trước khi thêm vào giỏ hàng",
      );
      hasError = true;
    }

    if (!isSizeSelectionComplete) {
      NotificationManager.warning(
        "Vui lòng chọn kích thước trước khi thêm vào giỏ hàng",
      );
      hasError = true;
    }

    if (!isFlavorSelectionComplete) {
      NotificationManager.warning(
        "Vui lòng chọn vị trước khi thêm vào giỏ hàng",
      );
      hasError = true;
    }

    if (!hasError && isSelectedVariantOutOfStock) {
      NotificationManager.warning("Biến thể này đã hết hàng");
      hasError = true;
    }

    if (
      !hasError &&
      hasSelectedVariantQuantity &&
      quantity > selectedVariantQuantity
    ) {
      NotificationManager.warning(
        `Số lượng tồn kho chỉ còn ${AddCommaNumber(selectedVariantQuantity)}`,
      );
      hasError = true;
    }

    if (hasError) {
      setShowErrors(true);
      return;
    }

    if (fullySelectedProduct || product) {
      const quantityToAdd = quantity > 0 ? quantity : 1;
      const added = await onClickImage(
        fullySelectedProduct || product,
        undefined,
        quantityToAdd,
      );
      if (added === false) return;
    }
    setProductDetail(null); // Đóng modal
  };

  const selectedVariant = fullySelectedProduct?.selectedVariant;

  const retailPrice = selectedVariant
    ? parseFloat(selectedVariant.promo_price) > 0
      ? parseFloat(selectedVariant.promo_price)
      : parseFloat(selectedVariant.price)
    : targetProduct.active_sale && parseFloat(targetProduct.price_sale) > 0
      ? parseFloat(targetProduct.price_sale)
      : parseFloat(targetProduct.price) || 0;

  const wholesalePrice = isFnB
    ? 0
    : selectedVariant
      ? parseFloat(selectedVariant.price_wholesale)
      : parseFloat(targetProduct.price_wholesale) || 0;

  return (
    <Modal
      isOpen={product !== null}
      toggle={() => setProductDetail(null)}
      wrapClassName="modal-right"
      backdrop={true}
    >
      <ModalHeader
        className="align-items-center w-100"
        toggle={() => setProductDetail(null)}
      >
        <div className="d-flex flex-wrap align-items-center">
          <span className="mr-2">{product?.name}</span>
          {/* {retailPrice > 0 && (
            <span
              style={{ fontSize: "14px", fontWeight: "normal", color: "#555" }}
            >
              - {AddCommaNumber(retailPrice)} đ
              {wholesalePrice > 0 && (
                <span
                  className="badge badge-secondary ml-2"
                  style={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                >
                  Sỉ: {AddCommaNumber(wholesalePrice)} đ
                </span>
              )}
            </span>
          )} */}
        </div>
      </ModalHeader>
      <ModalBody className="scrool modal-right-add">
        {product && (
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            id="modal-right__body"
          >
            <ProductDetailNow
              product={fullySelectedProduct || product}
              // onSelected phải luôn là setFullySelectedProduct để lưu lại lựa chọn của user
              // onToggleDetail chỉ dùng để MỞ modal, không dùng cho callbacks bên trong
              onSelected={setFullySelectedProduct}
              showErrors={showErrors}
            />
          </PerfectScrollbar>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="product-detail-add-actions w-100">
          <InputGroup size="md" className="mb-0 product-detail-quantity-group">
            <InputGroupAddon addonType="prepend">
              <Button
                outline
                color="primary"
                onClick={() =>
                  setQuantity((prevQuantity) =>
                    prevQuantity - 1 > 0 ? prevQuantity - 1 : 1,
                  )
                }
                className="border-btn-left"
              >
                -
              </Button>
            </InputGroupAddon>
            <Input
              type="number"
              min="1"
              max={
                hasSelectedVariantQuantity && selectedVariantQuantity > 0
                  ? selectedVariantQuantity
                  : undefined
              }
              disabled={isSelectedVariantOutOfStock}
              className="input-order"
              value={quantity}
              onChange={handleQuantityChange}
            />
            <InputGroupAddon addonType="append">
              <Button
                outline
                color="primary"
                onClick={() =>
                  setQuantity((prevQuantity) => {
                    const nextQuantity = prevQuantity + 1;
                    if (
                      hasSelectedVariantQuantity &&
                      selectedVariantQuantity > 0
                    ) {
                      return nextQuantity > selectedVariantQuantity
                        ? selectedVariantQuantity
                        : nextQuantity;
                    }
                    return nextQuantity;
                  })
                }
                disabled={
                  isSelectedVariantOutOfStock ||
                  (hasSelectedVariantQuantity &&
                    quantity >= selectedVariantQuantity)
                }
                className="border-btn-right"
              >
                +
              </Button>
            </InputGroupAddon>
          </InputGroup>
          <Button
            color="primary"
            onClick={handleAddToCart}
            disabled={isSelectedVariantOutOfStock}
            className="product-detail-add-btn"
          >
            {isSelectedVariantOutOfStock ? "Hết hàng" : "Thêm vào giỏ hàng"}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ContentComponent;
